var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M11.85 23.186c-.326-.044-.132.134-3.218-2.946a290 290 0 0 1-2.92-2.936c-.143-.177-.2-.35-.2-.606 0-.168.013-.248.055-.357.106-.275.37-.519.652-.604.202-.061.49-.041.693.049.147.064.263.175 2.118 2.025l1.962 1.957v-9.011c0-5.734.009-9.063.024-9.154.05-.312.271-.6.568-.74.152-.072.182-.077.416-.077s.264.005.415.077c.297.14.518.428.57.74.014.09.023 3.42.023 9.154v9.011l1.962-1.957c1.853-1.849 1.97-1.96 2.118-2.026.205-.09.506-.11.7-.047.477.158.78.64.697 1.11-.062.348.132.136-2.99 3.265-1.573 1.575-2.907 2.895-2.966 2.935-.18.12-.433.171-.678.138",
  clipRule: "evenodd"
})));
export default SvgArrowDown;